import {getMedicationProfileFormDefaultValues} from '@/modules/drug-catalog/medication-profiles/functions'
import {MedicationProfileFormSchema} from '@/modules/drug-catalog/medication-profiles/schemas'
import {DrugItemFormSchema} from '@/modules/drug-catalog/schemas'
import {getStabilityRuleFormDefaultValues} from '@/modules/drug-catalog/stability-rules/functions'
import {StabilityRuleFormSchema} from '@/modules/drug-catalog/stability-rules/schemas'
import {
  CancerStages,
  CatalogType,
  DoseCalcModeActive,
  DurationUnit,
  ExpiryRuleType,
  FormType,
  GfrMethod,
  MicrobiologicalLimitation,
  OralQuantityBasis,
  OverdosePreventionLevel,
  PreparationType,
  RoundingMode,
  SerumUnit,
  StabilityStage,
  VolumeMode,
} from '@cypro/engine/database/schema'
import {revalidateLogic} from '@tanstack/react-form'
import {LuBeaker, LuDroplets, LuFlaskConical} from 'react-icons/lu'

export const doseCalculationMethodOptions = Object.values(DoseCalcModeActive.enum)
export const roundingModeOptions = Object.values(RoundingMode.enum)
export const durationUnitOptions = Object.values(DurationUnit.enum)
export const overdosePreventionLevelOptions = Object.values(OverdosePreventionLevel.enum)
export const preparationTypeOptions = Object.values(PreparationType.enum)
export const formTypeOptions = Object.values(FormType.enum)
export const volumeModeOptions = Object.values(VolumeMode.enum)
export const oralQuantityBasisOptions = Object.values(OralQuantityBasis.enum)
export const stabilityStageOptions = Object.values(StabilityStage.enum)
export const expiryRuleOptions = Object.values(ExpiryRuleType.enum)
export const microbiologicalLimitOptions = Object.values(MicrobiologicalLimitation.enum)
export const cancerStagesOptions = Object.values(CancerStages.enum)
export const catalogTypeOptions = Object.values(CatalogType.enum)
export const gfrCalculationMethodOptions = Object.values(GfrMethod.enum)
export const serumUnitOptions = Object.values(SerumUnit.enum)

export const DrugItemFormDialogsIds = {
  medicationProfile: 'medication-profile',
  stabilityRule: 'stability-rule',
}

export const DrugItemFormOptions = {
  defaultValues: {} as DrugItemFormSchema,
}

export const MedicationProfileFormOptions = {
  defaultValues: getMedicationProfileFormDefaultValues(undefined),
  validators: {onDynamic: MedicationProfileFormSchema},
  validationLogic: revalidateLogic(),
  onSubmitMeta: {index: -1},
}

export const StabilityRuleFormOptions = {
  defaultValues: getStabilityRuleFormDefaultValues(undefined),
  validators: {onDynamic: StabilityRuleFormSchema},
  validationLogic: revalidateLogic(),
  onSubmitMeta: {index: -1},
}

export const DrugTypeToIconMap = {
  [CatalogType.enum.ACTIVE_SUBSTANCE]: LuFlaskConical,
  [CatalogType.enum.SOLUTION]: LuDroplets,
  [CatalogType.enum.SUPPORTIVE_MEDICATION]: LuBeaker,
} as const
